<template>
  <div v-loading.body="loading">
    <el-form :inline="false">
      <el-form-item label="请选择导出任务">
        <el-select
          v-model="form.task_name"
          size="mini"
          filterable
          value-key="id"
          placeholder="请选择导出类型"
          @change="currentSel"
        >
          <el-option
            v-for="item in task"
            :key="item.id"
            :value="item"
            :label="item.task_name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="show" ref="form">
        <OperateTaskFormItem
          v-for="(item, index) in where_type"
          :key="index"
          :form-item="item"
          :task-name="form.task_name"
          @change="updateWhere"
        ></OperateTaskFormItem>
      </div>
    </el-form>
    <el-button type="success" size="mini" @click="output">导出</el-button>
  </div>
</template>

<script>
import OperateTaskFormItem from "./OperateTaskFormItem.vue";

export default {
  name: "OperateRecordExport",
  components: {
    OperateTaskFormItem,
  },
  data() {
    return {
      loading: false,
      task: this.getTaskList(),
      where_type: null,
      form: {
        task_id: "",
        where_arr: {},
      },
      Sel: null,
      show: false,
    };
  },
  methods: {
    output() {
      this.$http.post("/erp/OperateLog/submitTask", this.form).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("已提交导出任务!");
        }
      });
    },
    exportDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 2);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    currentSel(Sel) {
      this.show = false;
      this.form.task_id = Sel.id;
      this.form.task_name = Sel.task_name;
      this.form.where_arr = {};
      if (Sel.has_where == 1) {
        this.where_type = Sel.where_config;
        this.show = true;
      } else {
        this.form.where_arr = {};
        this.show = false;
      }
    },
    getTaskList() {
      this.$http.post("/erp/OperateLog/getTaskList", {}).then((res) => {
        if (res.data.code === 200) {
          this.task = res.data.data.list;
        } else {
          this.$message.error("获取导出任务列表失败");
        }
      });
    },
    updateWhere(e) {
      console.log("接收emit：", e);
      if (e.value.length > 0) {
        console.log("update where", e.name);
        // this.form.where_arr[e.name] = {
        //   field: e.field,
        //   as: e.as,
        //   type: e.type,
        //   value: e.value,
        // };

        this.$set(this.form.where_arr, e.name, {
          field: e.field,
          as: e.as,
          type: e.type,
          value: e.value,
        });
      } else {
        console.log("delete where", e.name);
        delete this.form.where_arr[e.name];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/OperateRecordExport.vue